import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { UIIconColor } from './icon-color.type';
import { UIIcon } from './icon.enum';

interface UIIconSize {
  width: string;
  height: string;
}

@Component({
  selector: 'ui-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIIconComponent {
  readonly icon = input<`${UIIcon}`>(UIIcon.Activate);
  readonly description = input<string>();
  readonly sizeInPixels = input<number>(24);
  readonly color = input<UIIconColor>();
  readonly direction = input<'up' | 'down' | 'left' | 'right'>('up');

  readonly svgStyles = computed<UIIconSize>(() => {
    const size = this.sizeInPixels();
    return { width: `${size}px`, height: `${size}px` };
  });

  get iconClass(): string {
    const color = this.color();
    return [color && `ui-icon--color-${color}`, `ui-icon--direction-${this.direction()}`].filter(Boolean).join(' ');
  }
}
